import React, {useState,useEffect} from 'react';
import '../../../App.css';
import Navbar from '../../../components/Navbar';
import Banner from '../../../components/Banner';
import Contact from '../../../components/Contact';
import Footer from '../../../components/Footer';
import Reaction from '../../../components/Reaction';
import LastUpdate from '../../../components/LastUpdate';
import PhoneInfo from '../../../local-assets/faq-detail/phone-lot-reserve-parking.png';

const Index = () => {

    React.useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
   
    return (
        <div className="bg-white min-h-screen  flex flex-col">
            <Navbar />
            
            {/* Banner Section */}
            <Banner
                image={process.env.REACT_APP_S3 + "banner_faq.png"} 
                beforePage="FAQ"
                currentPage="Detail FAQ" 
            />
            <div className="mx-auto px-4 md:px-24 w-full relative z-10 mb-16">
                <div className="rounded-2xl md:rounded-3xl">
                    <div className="mb-10 md:mb-16 max-w-4xl">
                        <h1 className="text-2xl md:text-3xl lg:text-3xl font-bold text-[#101828] mb-6 leading-snug">
                            Mengapa jumlah lot saat book reserve parking di apps dan di lapangan berbeda?
                        </h1>
                    </div>

                    {/* Mapping Blok Konten (Kiri Teks, Kanan Gambar) */}
                    <div className="flex flex-col gap-12 md:gap-20">
                      <div className="flex flex-col md:flex-row gap-8 md:gap-12">
                          <div className="w-full md:w-1/2 text-left justify-center md:justify-end">
                            <label className="text-[#101828] text-lg md:text-lg">
                              Perbedaan jumlah lot saat memesan tempat parkir melalui aplikasi dan di lapangan bisa disebabkan oleh beberapa faktor:
                            </label>
                            
                            <ol className="list-decimal pl-5 mt-4 text-[#475467]">
                              <li className="mb-4">
                                <strong className="text-[#101828]">Data Aplikasi Tidak Real Time:</strong> 
                                {" "}Dibutuhkan waktu untuk sinkronisasi data, sehingga jumlah lot yang tersedia di aplikasi tidak sesuai dengan di lapangan.
                              </li>
                              <li className="mb-4">
                                <strong className="text-[#101828]">Kendala Pada Gate Parkir:</strong>
                                {" "}Kendala pada gate parkir dapat menyebabkan ketidaksesuaian antara jumlah lot yang ditampilkan di aplikasi dan yang ada di lapangan.
                              </li>
                              <li className="mb-4">
                                <strong className="text-[#101828]">Reservasi yang Tidak Terlacak:</strong>
                                {" "}Jika seseorang memesan tempat parkir tetapi tidak segera menggunakannya atau tidak membatalkan reservasi, tempat tersebut mungkin dianggap tersedia di aplikasi tetapi sebenarnya tidak bisa digunakan.
                              </li>
                            </ol>
                          </div>

                          {/* Kolom Kanan: Gambar */}
                          <div className="w-full md:w-1/2 flex items-start md:items-start">
                              {/* Box background hijau/abu-abu muda seperti di desain */}
                              <div className="rounded-3xl px-6 md:px-8 w-full max-w-[640px] flex justify-center items-center">
                                  <img
                                      src={PhoneInfo}
                                      className="w-full h-auto object-contain drop-shadow-xl"
                                  />
                              </div>
                          </div>
                      </div>
                    </div>
                    <LastUpdate/>
                </div>
            </div>
            
            <Contact />
            <Footer />
        </div>
    );
}

export default Index;